import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import { trackButtonClick } from "@/utils/analytics";

const AssignmentContract = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="mb-3 pl0">
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="kck8fNh0n4k"
        onClose={() => setIsOpen(false)}
      />
      <img
        className="img-whp w-100 cover cursor-pointer"
        onClick={() => {
          setIsOpen(true)
          trackButtonClick({
            eventName: "assignment_contract_video_clicked",
            eventCategory: "NEW-PDP",
            eventSource: "on assignment contract video click",
          })
        }}
        src={"https://image-prod.hubzu.com/PLT/Assignment_contracts_1.jpg"}
        alt="PLT assignment contract.jpg"
        data-toggle="tooltip" data-placement="bottom" title="Learn how assignment contracts work"
      />
    </div>
  );
};

export default AssignmentContract;
